import CardView from './Card';
import { TextFieldComponent } from './inputField';

type SearchComponentProps = {
  searchValue?: string;
  handleSelection?: (name: string, value: string) => void;
  divCss?: string;
};
export function SearchComponent({
  searchValue = '',
  handleSelection = (name, value) => {},
  divCss = ''
}: SearchComponentProps) {
  return (
    <TextFieldComponent
      placeholder="Search"
      divCss={divCss}
      value={searchValue}
      handleSelection={handleSelection}
    />
  );
}
type itemType = {
  author: string;
  currentVersion: string;
  description: string;
  title: string;
  totalVersions: number;
  tags: string[];
  is_new: boolean;
  promptID?: string;
  prompt_id?: string;
  is_prompt_type_private: boolean;
  versionDetail?: string;
  latest_version_id?: string;
  versions?: {}[];
};
type FilterComponent = {
  isAllPrompt?: boolean;
  allPromptCardsData?: itemType[];
  myPromptCardsData?: itemType[];
  searchValue?: string;
  selectedTerms?: string[];
};
export function FilterComponent({
  isAllPrompt = false,
  allPromptCardsData = [],
  myPromptCardsData = [],
  searchValue = '',
  selectedTerms = []
}: FilterComponent) {
  // Return all data if no filters are applied
  const temp = isAllPrompt ? allPromptCardsData : myPromptCardsData;
  if (!searchValue && (!selectedTerms || selectedTerms.length === 0)) {
    return temp;
  }

  // Filter by searchValue
  let filteredData = temp;
  if (searchValue) {
    filteredData = filteredData.filter((item) =>
      item.title?.toLowerCase().includes(searchValue.toLowerCase())
    );
  }

  // Filter by selectedTerms
  if (selectedTerms && selectedTerms.length > 0) {
    filteredData = filteredData.filter((item) =>
      item.tags?.some((tag) => selectedTerms.includes(tag))
    );
  }

  return filteredData;
}

export function CardComponent({
  handleFilter = () => {},
  isAllPrompt = true,
  setCopyPrompt = (a: boolean) => {},
  setSelectedCard = (a: number) => {},
  setDeletePopUp = (a: boolean) => {},
  setVersionsPopUp = (a: boolean) => {},
  isPromptLibrary = false
}) {
  return (
    <div
      style={{
        height: '90%',
        overflow: 'auto',
        scrollbarWidth: 'none'
      }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(400px, 1fr))',
          gap: '16px',
          padding: '12px'
        }}>
        {handleFilter()?.length ? (
          handleFilter()?.map((card, index) => (
            <CardView
              isPromptLibrary={isPromptLibrary}
              key={card?.description + index}
              card={card}
              allPrompt={isAllPrompt}
              handleCopyButton={() => {
                setCopyPrompt(true);
                setSelectedCard(index);
              }}
              handleDeleteButton={() => {
                setDeletePopUp(true);
                setSelectedCard(index);
              }}
              handleVersionClick={() => setVersionsPopUp(true)}
            />
          ))
        ) : (
          <p>Sorry, No Data Found...</p>
        )}
      </div>
    </div>
  );
}

export function PromptTypeButtonComponent({ isAllPrompt = true, handleClick = () => {} }) {
  return (
    <div
      className="toggleButtonMainBox"
      onClick={() => {
        handleClick();
      }}>
      {['All Prompt', 'My Prompts']?.map((item, index) => (
        <div
          key={item + index}
          className={`${
            [isAllPrompt, !isAllPrompt][index] ? 'blueButton h5_400' : 'h5_400'
          } alignDataCenter promptToggleButton`}>
          {item}
        </div>
      ))}
    </div>
  );
}

export function ToggleButton({
  buttonNames = ['abc', 'def'],
  selectedButtonIndex = 0,
  handleClick = () => {}
}) {
  return (
    <div
      className="toggleButtonMainBox"
      onClick={() => {
        handleClick();
      }}>
      {buttonNames?.map((item, index) => (
        <div
          key={item + index}
          className={`${
            selectedButtonIndex === index ? 'blueButton h5_400' : 'h5_400'
          } alignDataCenter promptToggleButton`}>
          {item}
        </div>
      ))}
    </div>
  );
}
